import DetailLeftContainer from '@components/atoms/container/detailLeftContainer';
import DetailEvent from '@components/elements/detail/detailEvent';
import DetailRelated from '@components/elements/detail/detailRelated';
import DetailSynopsis from '@components/elements/detail/detailSynopsis';

export default function DetailLeft() {
  return (
    <DetailLeftContainer id='detailLeft'>
      <DetailEvent />
      <DetailSynopsis />
      <DetailRelated />
    </DetailLeftContainer>
  );
}
